import { useEffect } from 'react'
import { IoMdClose } from 'react-icons/io'

import { useMainGlobalContext } from '../../context/GlobalContext'
import CustomCreatePostWrapper from '../../components/custom/wrapper/CustomCreatePostWrapper'

interface Props {
  profilePicture: string | null
}

const Overlay: React.FC<Props> = ({ profilePicture }) => {
  const { dispatch } = useMainGlobalContext()

  useEffect(() => {
    document.body.classList.add('no-scroll')

    return () => {
      document.body.classList.remove('no-scroll')
    }
  }, [])

  return (
    <div className="fixed right-0 left-0 z-[100] h-dvh w-dvw bg-[#1D1F23]/50 backdrop-opacity-90 backdrop-saturate-150">
      <div className="overlay-post">
        <div className="flex w-full pt-[7px] pl-[7px]">
          <button
            className="hover-main flex h-[40px] w-[40px] items-center justify-center rounded-full text-2xl"
            onClick={() => {
              dispatch({ type: 'CLOSE_POST_OVERLAY' })
            }}
          >
            <IoMdClose />
          </button>
        </div>
        <div className="flex w-full max-w-[600px]">
          <CustomCreatePostWrapper profilePicture={profilePicture} />
        </div>
      </div>
    </div>
  )
}

export default Overlay
